exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".advancedCard label{\n  color:white;\n}\n.sorthead {\n  cursor: pointer;\n}\n.tableWrap {\n  background: none;\n  height: 500px;\n}\n.tableWrap thead {\n  background-color: black;\n}\n.tableWrap td, .tableWrap th {\n\n}\n\n.table-scroll tbody {\n  position: absolute;\n  overflow-y: scroll;\n  height: 450px;\n}\n\n.table-scroll tr {\n  width: 100%;\n  table-layout: fixed;\n  display: inline-table;\n}\n\n.table-scroll thead > tr > th {\n  border: none;\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/remnants/remnants.component.css
// module id = 448
// module chunks = 0